import { useSelector } from "react-redux"
import { AppState } from "state"

export const useAirdropSelector = () => {
    const data = useSelector((state: AppState) => state.airdrop)
    return data
}